<template>
	<div id="buildingRightBottom2">
		<dv-border-box-6>
			<div class="d-flex pt-2 pl-2">
				<div class="d-flex">
					<span class="mt-3 ml-3 title_t">年用能变化</span>
				</div>
			</div>
			<div class="box-content d-flex jc-around">
				<div class="left">
					<div class="list">
						<div class="ml-2">
							<span class="listText">累计用能</span>
							<span class="show">{{ totalData.sum_dnsj }}</span>
							<span class="ml-3">度</span>
						</div>
						<div class="ml-2">
							<span class="listText">空调用能</span>
							<span class="show">{{ totalData.air_dnsj }}</span>
							<span class="ml-3">度</span>
						</div>
						<div class="ml-2">
							<span class="listText">水泵用能</span>
							<span class="show" style="width: 1.25rem;margin-left: 0.2rem;">{{ totalData.pump_dnsj }}</span>
							<span class="ml-3">度</span>
						</div>
						<div class="ml-2">
							<span class="listText" style="width: 1.25rem;">冷却塔用能</span>
							<span class="show" style="width: 1.25rem;">{{ totalData.cooling_dnsj }}</span>
							<span class="ml-3">度</span>
						</div>
					</div>
				</div>
				<div class="right">
					<div id="buildingRightChart" style="width: 100%; height: 2.8rem;"></div>
				</div>
			</div>
		</dv-border-box-6>
	</div>
</template>

<script>
	import echarts from "echarts"
	export default {
		data() {
			return {
				chart: null,
				chartData: [],
				totalData: {}
			};
		},
		components: {
			
		},
		props: ['building'],
		watch: {
			'building': {
				handler() {
					this.yearEnergyVariation();
				},
			}
		},
		mounted() {
			this.yearEnergyVariation();
		},
		methods: {
			async yearEnergyVariation() {
				let dataObj = {
					building_id: this.building,
				}
				await this.$axios.get("/api/buildings/yearEnergyVariation", {
					params: dataObj
				}).then(res => {
					let timeData = []
					let airData = []
					let pumpData = []
					let coolingData = []
					for(let item of res.data.data.year_dnsj){
						timeData.push(item.year)
						airData.push(item.air_dnsj)
						pumpData.push(item.pump_dnsj)
						coolingData.push(item.cooling_dnsj)
					}
					this.chartData = [timeData, airData, pumpData, coolingData]
					this.totalData = res.data.data.sum
					this.draw();
				})
			},
			draw() {
				// 基于准备好的dom，初始化echarts实例
				this.chart = this.$echarts.init(
					document.getElementById("buildingRightChart"), 'dark'
				);
			
				let option = {
					backgroundColor: 'rgb(255,255,255,0)', //背景色
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					legend: {
						show: true,
						orient: 'horizontal',
						x: 'center',
						top: 0,
						textStyle: {
							fontSize: 12,
							fontWeight: 'bold',
							color: '#fff'
						},
					},
					xAxis: {
						type: "category",
						data: this.chartData[0],
						axisLabel: {
							show: true,
							textStyle: {
								color: '#fff'
							}
						},
						axisTick: {
							show: false
						}
					},
					yAxis: {
						type: "value",
						axisLabel: {
							formatter: function(value) {
								if (value >= 1000) {
									value = value / 1000 + "k";
								} else if (value < 1000) {
									value;
								}
								return value;
							},
							textStyle: {
								color: '#fff'
							}
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: '#323232',
								type: "dashed"
							}
						}
					},
					series: [{
						type: "bar",
						name: "空调",
						stack: true,
						data: this.chartData[1],
						itemStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
									offset: 0,
									color: "#30CEEF"
								}, {
									offset: 1,
									color: "#317FEF"
								}], false)
							}
						},
						barWidth: 20
					},{
						type: "bar",
						name: "水泵",
						stack: true,
						data: this.chartData[2],
						itemStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
									offset: 0,
									color: "#31DCE7"
								}, {
									offset: 1,
									color: "#43F0B7"
								}], false)
							}
						},
						barWidth: 20
					},{
						type: "bar",
						name: "冷却塔",
						stack: true,
						data: this.chartData[3],
						itemStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
									offset: 0,
									color: "#BCE4FB"
								}, {
									offset: 1,
									color: "#86CBF3"
								}], false)
							}
						},
						barWidth: 20
					}],
				};
			
				this.chart.setOption(option);
			},
		},
	};
</script>

<style lang="scss">
	#buildingRightBottom2 {
		height: 3.2125rem;
		width: 8.575rem;
		
		.box-content{
			width: 100%;
			height: 3.2rem;
			.left{
				padding: 0.2rem;
				width: 40%;
				color: #fff;
				p{
					font-size: 0.1875rem;
				}
				span{
					font-size: 0.1625rem;
				}
				.show{
					display: inline-block;
					width: 1.5rem;
					height: 0.375rem;
					font-size: 0.3125rem;
					background-image: linear-gradient(#1C658C, #2C3333, #1C658C);
					color: #fff;
					border-radius: 2px;
					text-align: center;
					line-height: 0.375rem;
				}
				.list>div{
					width: 3.75rem;
					height: 0.6rem;
					line-height: 0.6rem;
					.listText{
						display: inline-block;
						width: 1rem;
						font-size: 0.2125rem;
					}
				}
			}
			.right{
				width: 60%;
			}
		}
	}
</style>
